<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="3" md="4" class="p-a-0 m-t-5px">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="3" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="cliente"
              :options-limit="300"
              :limit="10"
              :limit-text="limitText"
              :options="optionsCliente"
              track-by="value"
              label="label"
              id="cliente"
              :hide-selected="true"
              placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingCliente"
              @search-change="listaClientesPessoa"
            ></multiselect>
          </b-col>
          <b-col sm="1" md="1" class="m-t-5px p-a-0">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsLivStatusFilter"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_receita_despesa"
              :options="this.$parent.optionsTpReceitaDespesaFilter"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Processo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_processo"
              :options="this.$parent.optionsTpProcesso"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo de Processo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_calc"
              :options="this.$parent.optionsTpCalc"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo de cálculo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="unidade"
              :options="this.$parent.optionsUnidade"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="3" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({
        params: [],
        search: "",
      }),
      isLoadingTransportadora: false,
      isLoadingCliente: false,
      transportadora: [],
      optionsTransportadora: [],
      optionsLivStatusFilter: [],
      dt_emi_ini: "",
      dt_emi_fim: "",
      tp_processo: "",
      unidade: "",
      num_carga: "",
      unidade: [],
      optionsUnidade: [],
      data_filter: [],
      status: [],
      cliente: [],
      tp_calc: [],
      tp_receita_despesa: [],
      optionsCliente: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        transportadora: this.transportadora,
        status: this.status,
        unidade: this.unidade,
        tp_processo: this.tp_processo,
        cliente: this.cliente,
        tp_receita_despesa: this.tp_receita_despesa,
        tp_calc: this.tp_calc,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.transportadora = "";
      this.status = "";
      this.unidade = "";
      this.tp_processo = "";
      this.cliente = "";
      this.tp_receita_despesa = "";
      this.tp_calc = "";

      this.$events.fire("filter-reset");
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesPessoa(search) {
      if (search.length >= 3) {
        this.isLoadingCliente = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/cliente")
          .then((response) => {
            this.optionsCliente = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.razao_social,
                  cpf: null,
                  cnpj: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ).replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  ),
                  ie: obj.inscricao_estadual,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.nome,
                  cpf: obj.cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    "$1.$2.$3-$4"
                  ),
                  cnpj: null,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.nome,
                  cpf: null,
                  cnpj: obj.cuit,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingCliente = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
